import NotepadTasks from './NotepadTasks';

export { NotepadTasks };
export default NotepadTasks;
